import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import cityNameRenderer from '../../../components/dynamicComponent/CityNameRenderer';
import GenerateOrderButton from '../../../components/common/generateorder';
import IndentFromVehicleButton from '../../../components/common/indentFromVehicleButton';
import IndentFromBookingModal from '../../../components/common/indentFromBookingModal';


import vehicleRenderer from '../../../components/dynamicComponent/VehicleRenderer';
import vehicleTypeRenderer from '../../../components/dynamicComponent/VehicleTypeRenderer';
import { isEmpty } from "lodash";
import moment from 'moment';
import allAxiosCommonTA from "../../../components/axiosComponent/allAxiosCommonTA";
import { FEATURES } from "../../../utils/constant";


class VehicleAvailability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
      openIndent: false,
      vehicleIDClicked: ''
    };
  }

  componentDidMount() {
    if (this.props.location?.state?.filterProp?.typeFrom === "planning") {
      this.vehicleAvailabilityWithFilterAPICall(this.props.location?.state?.filterProp)
    } else {
      this.vehicleAvailabilityApiCall();
    }
  }

  vehicleAvailabilityWithFilterAPICall(filterElements) {
    let searchIdFilter = ""
    if (filterElements?.city_id)
      searchIdFilter = searchIdFilter.concat("&city_id=" + filterElements.city_id)
    if (filterElements?.booking_branch_id)
      searchIdFilter = searchIdFilter.concat("&booking_branch_id=" + filterElements.booking_branch_id)
    if (filterElements?.vendor_id)
      searchIdFilter = searchIdFilter.concat("&vendor_id=" + filterElements.vendor_id)
    if (filterElements?.load_type_id)
      searchIdFilter = searchIdFilter.concat("&load_type_id=" + filterElements.load_type_id)
    if (filterElements?.vehicle_type_id)
      searchIdFilter = searchIdFilter.concat("&vehicle_type_id=" + filterElements.vehicle_type_id)

    let filterList = filterElements.filter_type.toString()

    allAxiosCommonTA({ url: "/vehicle/availability/active", method: "get", getValues: `filter_type=${filterList}` + `${searchIdFilter}` + `&availability_date=${filterElements.availability_date}&` })
      .then((res) => {
        this.setState({
          rowData: isEmpty(res) ? [] : res.data.data,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log("err", err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  vehicleAvailabilityApiCall() {
    let user_id = +localStorage.getItem("userId")
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/vehicle/availability/active?${user_id}` })
      .then((res) => {
        console.log(res);
        this.setState({
          rowData: isEmpty(res) ? [] : res.data.data,
          loadingData: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_DRIVER_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  openIndentModal = (data) => {
    this.setState({ openIndent: true, vehicleIDClicked: data });
  }

  closeIndentModal = () => {
    this.setState({ openIndent: false });
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-branch", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/vehicleavailability");
    this.props.history.go();
  };

  onRowerror = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const headerChange = () => {
      if (localStorage.getItem('customerNumber') == 1158) {
        return t("table_header.partner_name") || "Partner"
      } else {
        return t("table_header.vendor_name") || "Vendor"
      }
    }
    const Columns = [
      {
        headerName: `${headerChange()}`,
        field: "vendor_name",
        sortable: true,
        filter: true,
        // cellRenderer: 'vehicleRenderer'
      },
      {
        headerName: t("table_header.vehicle_number") || "Vehicle Number",
        field: "vehicle_number",
        sortable: true,
        filter: true,
        // cellRenderer: 'vehicleRenderer'
      },
      {
        headerName: t("table_header.status") || "Status",
        field: "status",
        sortable: true,
        filter: true,
        cellRendererFramework: (params) => <div>
          {console.log("Statuscolor : ", params)}
          {params.data.status_code == "ACT" ?
            <span style={{ color: "green" }} > {params.value} </span> :
            (params.data.status_code == "INACT" ? <span style={{ color: "orange" }} > {params.value} </span> :
              <span style={{ color: "red" }} > {params.value} </span>)}
        </div>
      },
      {
        headerName: t("table_header.vehicle_type") || "Vehicle Type",
        field: "vehicle_type",
        sortable: true,
        filter: true,
        // cellRenderer: 'vehicleTypeRenderer'
      },
      {
        headerName: t("table_header.load_type") || "Load Type",
        field: "load_type",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.temp_range") || "Temperature Range",
        field: "temperature",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.city") || "City",
        field: "city_name",
        sortable: true,
        filter: true,
        // cellRenderer: 'cityNameRenderer'
      },
      {
        headerName: t("table_header.start_date") || "Availability Start Date",
        field: "start_date",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.end_date") || "Availability end Date",
        field: "end_date",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.is_vehicle_utilized") || "Is Vehicle Utilized",
        field: "is_vehicle_utilised",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.indent") || "Indent",
        field: "edit",
        cellRenderer: "IndentFromVehicleButton",
        pinned: "right",
        suppressToolPanel: true,
      },
      {
        headerName: t("table_header.action") || "Action",
        field: "edit",
        cellRenderer: "generateorder",
        pinned: "right",
        suppressToolPanel: true,
      },
    ];

    let rowItems = []

    if (this.state.rowData) {
      this.state.rowData.map((o, i) => {
        console.log(o, o.min_temp)
        let temp = {}
        temp.status_code = o.status_code
        temp.id = o.transporterMasterId
        temp.vendor_name = o.vendor_name
        temp.created_on = moment.parseZone(o.created_on).format('DD-MM-YYYY HH:mm')
        temp.load_type = o.load_type.load_type_name
        temp.load_type_id = o.load_type_id
        temp.vehicle_type_id = o.vehicle_type_id
        temp.is_vehicle_utilised = o.is_vehicle_utilised
        temp.vendor_id = o.vendor_id
        temp.city_id = o.city_id
        temp.vehicle_id = o.vehicle_id
        temp.vehicle_number = o.vehicle_number
        temp.vehicle_type = o.vehicle_type
        temp.city_name = o.city_name
        temp.start_date = o.availability_start_time
        temp.end_date = o.availability_end_time
        temp.vehicle_id = o.vehicle_id
        temp.vehicle_availability_id = o.vehicle_availability_id
        temp.max_temp = o.max_temp
        temp.min_temp = o.min_temp
        temp.temperature = o.min_temp != null || o.max_temp != null ? (o.min_temp != null ? o.min_temp + " \u00b0 C - " : "NA ") + (o.max_temp != null ? o.max_temp + " \u00b0 C" : "NA") : "-"
        temp.date = moment.parseZone(o.createdOn).format('DD-MM-YYYY HH:mm')
        temp.status = o.status
        rowItems[i] = temp
      })
    }
    else {
      rowItems[0] = ""
    }

    let framerComponent = {
      cityNameRenderer: cityNameRenderer,
      vehicleRenderer: vehicleRenderer,
      vehicleTypeRenderer: vehicleTypeRenderer,
      IndentFromVehicleButton: IndentFromVehicleButton
    }
    return (
      <React.Fragment>
        <AgGridTable
          addVehicleToVehicleAvailability={true}
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowItems}
          extraComponents={framerComponent}
          titleBarTitle={t("table_header.vehicle_availability") || "Vehicle Availability"}
          titleBarLink={"/vehicle-availability"}
          baseURL={"vehicleavailability"}
          keyIndex={"branchId"}
          //   onEdit={this.onRowEdit}
          //   cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          onEdit={this.onRowerror}
          openIndentModal={this.openIndentModal}
          hideRowEdit={!this.props.permissions.TA_DRIVER_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_DRIVER_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
        <IndentFromBookingModal modalOpen={this.state.openIndent} handleClose={this.closeIndentModal} vehicleID={this.state.vehicleIDClicked}></IndentFromBookingModal>
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(translate("vehicleavailability")(VehicleAvailability));
